import { getConfig } from "@config/index";

export const GLOBAL_BASE_URL = getConfig().BASE_URL;
export const SOCKET_SERVER_URL = `${GLOBAL_BASE_URL}/weChat`;
export const WEB_URL = getConfig().WEB_URL;
export const ADMIN_CONSOLE = getConfig().ADMIN_CONSOLE;

// API Versions
export const APIv1 = "/api/v1";
export const APIv2 = "/api/v2";
export const APIv3 = "/api/v3";

export const ANONYMOUS_ROUTES = [
  "/signin",
  "/register",
  "/roles",
  "/users/password",
];
export const AUTH_TOKEN_STORAGE_KEY = "@token";
export const AUTH_TOKEN_EXPIRED_MESSAGE = "Unauthorized";
export const DEFAULT_ERROR_MESSAGE = `Oops, Something's not right`;
export const NOT_REGISTERED_MOBILE_OR_EMAIL = `Provided Email or Mobile are not associated, please check again`;
export const ERR_WRONG_EMAIL_AND_PASSWORD = `Please provide valid Email/Mobile and Password`;
export const SUBMISSION_CLOSED = `This form is not accepting responses any more!`;
export const ERR_FORM_ALREADY_RESPONDED = "Multiple responses are restricted!";
export const ERR_ALREADY_REGISTERED = `Email/Mobile is already registered`;
export const ERR_UNSUPPORTED_VERSION = "ERR_UNSUPPORTED_VERSION";
export const UNDER_MAINTENANCE = "UNDER_MAINTENANCE";
export const ERR_PROFILE_NOT_FOUND = "ERR_PROFILE_NOT_FOUND";
export const ERR_USER_SETTING_DOES_NOT_EXISTS =
  "ERR_USER_SETTING_DOES_NOT_EXISTS";
export const ERR_PAST_TIMESTAMP = "ERR_PAST_TIMESTAMP";
export const ERR_MEETING_REQUEST_SENT = "ERR_MEETING_REQUEST_SENT";
export const ERR_MEETING_EXIST = "ERR_MEETING_EXIST";
export const ERR_INTERNAL_SERVER_ERROR = "ERR_INTERNAL_SERVER_ERROR";
export const ERR_SURVEY_REQUIRED = "ERR_SURVEY_REQUIRED";
export const MSG_EMAIL_NOT_FOUND = "MSG_EMAIL_NOT_FOUND";
export const MSG_INCORRECT_PASSWORD = "MSG_INCORRECT_PASSWORD";
export const NO_NETWORK =
  "Unable to connect. Please check your internet connection.";
export const SOMETHING_WENT_WRONG = "Something went wrong!";
export const ERR_INVALID_OTP = "ERR_INVALID_OTP";
export const ERR_INVALID_PASSWORD =
  "Invalid Password. Password can not be empty";
export const ERR_CONFIRM_PASSWORD_MISMATCH = "ERR_CONFIRM_PASSWORD_MISMATCH";
export const ERR_INVALID_EMAIL_ID = "Invalid Email id found";
export const ERR_PRIVACY_POLICY_NOT_ACCEPTED =
  "Privacy policy needs to be accepted";
export const ERR_USER_NOT_FOUND = "User not found";
export const ERR_USER = "ERR_USER";
export const ERR_USER_ALREADY_PRESENT = "ERR_USER_ALREADY_PRESENT";
export const ERR_ORGANIZATION_ALREADY_REGISTERED =
  "This Organization already registered! Please try with different Organization";
export const DATA_NOT_FOUND = "Data not found";
export const HTTP_STATUS_CODES = {
  Ok: 200,
  Created: 201,
  NoContent: 204,
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  Conflict: 409,
  UnprocessableEntity: 422,
  InternalServerError: 500,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  NotModified: 304,
};
export const HTTP_STATUS_VALUES= {
  Ok: 'OK',
}
